import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { addComment } from 'store/action/articles.action';
import Button from 'component/button.component';
import {
  ADD_ARTICLE_COMMENT_ERROR,
  ADD_ARTICLE_COMMENT_SUCCESS,
} from 'config/constants';
import { toast } from 'react-toastify';
import userImage from 'resource/img/user-default.png';

class ArticleComment extends PureComponent {
  state = {
    comment: '',
  };

  _onChangeComment = event =>
    this.setState({ comment: event.currentTarget.value });

  _addComment = () => {
    const { comment } = this.state;
    const { addComment, id } = this.props;
    addComment(id, comment).then(({ type, message }) => {
      if (type === ADD_ARTICLE_COMMENT_SUCCESS) {
        this.setState({ comment: '' }, () =>
          toast.success('Comentário enviado!')
        );
      } else if (type === ADD_ARTICLE_COMMENT_ERROR) {
        toast.error(message);
      }
    });
  };

  render() {
    const { comment } = this.state;
    const { user } = this.props;

    if (!user) return null;

    return (
      <div className="flex-column" id="commentArticle">
        <div className="flex-row align-center">
          <img
            src={user && user.image ? user.image : userImage}
            alt="User"
            style={{
              width: 40,
              height: 40,
              borderRadius: 40,
              margin: 15,
              marginLeft: 0,
            }}
          />
          <span>
            <strong>{user && user.name ? user.name : ''}</strong>, faça seu
            comentário sobre o artigo.
          </span>
        </div>
        <textarea
          value={comment}
          onChange={this._onChangeComment}
          placeholder="Escreva aqui..."
          style={{
            resize: 'none',
            padding: 5,
            outline: 'none',
            height: 100,
            fontSize: 15,
          }}
        ></textarea>
        <Button
          className="self-align-end"
          onClick={this._addComment}
          text="Comentar"
          style={{ marginTop: 20, backgroundColor: '#185335' }}
        />
      </div>
    );
  }
}

function mapStateToProps({ user }) {
  return {
    user,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    addComment: (id, comment) => dispatch(addComment(id, comment)),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ArticleComment);
